import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/features/auth';
import { ToastProvider } from '@/shared/ui';
import { LicenseNoticeProvider } from './LicenseNoticeProvider';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

/**
 * Wszystkie konteksty aplikacji w jednym miejscu.
 *
 * Kolejnosc ma znaczenie: router musi byc na zewnatrz `AuthProvider`,
 * bo ochrona tras korzysta z `useLocation`.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <ToastProvider>
        <LicenseNoticeProvider>
          <QueryProvider>
            <BrowserRouter>
              <AuthProvider>{children}</AuthProvider>
            </BrowserRouter>
          </QueryProvider>
        </LicenseNoticeProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
